import React, {ErrorInfo} from "react";

type Props = {
  children: React.ReactNode;
  fallback?: React.ComponentType;
  reporter?: (error: Error, errorInfo: ErrorInfo) => void;
}

type State = {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<Props, State>{
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error(error, errorInfo);
    if (this.props.reporter) {
      this.props.reporter(error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {{
        return <this.props.fallback />}
      }
      return <h1>Something went wrong.</h1>;
    }

    return this.props.children;
  }

}